import icChevRight from 'assets/images/ic-chevron-right-thin.svg'
import icArrowDown from 'assets/images/ic-arrow-down.svg'
import Breadcrumb from 'components/commons/breadcrumb'
import Popup from 'components/commons/popup'
import icUserDefault from 'assets/images/ic-user-profile.svg'

export const Header = ({
    breadcrumbPath,
    onNavigate,
    showLogout,
    setShowLogoutToggle,
    userProfile,
    isLoadingLogout,
    onClickLogout,
}) => {
    return (
        <div className='w-full flex items-center justify-between px-9 py-4 sticky top-0 bg-white z-20'>
            <Breadcrumb
                className='hris-breadcrumb'
                path={breadcrumbPath}
                separator={<img className='w-5 h-5' src={icChevRight} alt='chev right' />}
                onClick={onNavigate}
            />
            <div
                id={'logout'}
                className={'h-14 flex items-center space-x-10 border rounded px-2 cursor-pointer relative'}
                onClick={setShowLogoutToggle}
            >
                <div className={'flex items-center space-x-3 capitalize'}>
                    <img src={userProfile?.profile_picture || icUserDefault} className={'w-9'} alt={'user-profile'} />
                    <div>
                        <p className={'font-semibold'}>{userProfile?.name}</p>
                        <p className={'text-sm'}>{userProfile?.role}</p>
                    </div>
                </div>
                <img src={icArrowDown} className={'w-3'} alt={'icArrowDown'} />
                <Popup
                    className={'top-14 right-0'}
                    show={showLogout}
                    content={
                        <div
                            className={`p-2 cursor-pointer ${isLoadingLogout ? 'text-neutral-40 bg-text-neutral-10 hover:bg-neutral-10' : 'text-white bg-primary-100 hover:bg-blue-95'}`}
                            onClick={isLoadingLogout ? () => {} : onClickLogout}
                        >
                            Logout
                        </div>
                    }
                />
            </div>
        </div>
    )
}
